<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-disk-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.571 34.159v7.188A2.653 2.653 0 0139.918 44H8.082a2.653 2.653 0 01-2.653-2.653v-7.188H42.57zm-6.792 2.404h-2.334a2.37 2.37 0 00-.297 4.722l.297.019h2.334a2.37 2.37 0 100-4.741zM33.94 4a4.717 4.717 0 014.651 3.935l3.981 23.684H5.43L9.41 7.935A4.717 4.717 0 0114.061 4H33.94z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudDiskFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
